// 初期表示
export const PAGE_INIT = "corp/overseas/segment/country/PAGE_INIT";
